import { VariantRow } from "./VariantRow";
import { formatTime } from "../../utils/formatTime";

export const ChapterItem = ({
  chapter,
  index,
  currentTrack,
  isPlaying,
  progressPercent,
  durations,
  queueKeys,
  onPlayVariant,
  onToggleQueue,
}) => {
  const variants = [
    chapter.variants.resumen && { type: "resumen", label: "Resumen" },
    chapter.variants.completo && { type: "completo", label: "Completo" },
  ].filter(Boolean);

  const isChapterActive = currentTrack?.chapterId === chapter.id;

  return (
    <div
      className="rounded-2xl px-3 py-3 transition-colors"
      style={{
        background: isChapterActive ? "rgba(255,255,255,.09)" : "rgba(255,255,255,.04)",
        border: `1px solid ${isChapterActive ? "rgba(255,255,255,.18)" : "rgba(255,255,255,.07)"}`,
      }}
    >
      <div className="flex items-center gap-3">
        <div className="w-[3px] h-7 rounded-sm shrink-0" style={{ background: chapter.color }} />

        <span
          className="font-mono font-bold text-[11px] w-5 shrink-0"
          style={{ color: chapter.color }}
        >
          {String(index + 1).padStart(2, "0")}
        </span>

        <div className="flex-1 min-w-0">
          <p className="font-semibold text-[15px] text-white truncate">{chapter.name}</p>
          <div className="h-[3px] rounded-full bg-white/10 mt-2 overflow-hidden">
            <div
              className="h-full rounded-full transition-[width]"
              style={{ background: chapter.color, width: `${progressPercent}%` }}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-1.5 mt-2.5 pl-8">
        {variants.map(({ type, label }) => {
          const key = `${chapter.id}-${type}`;
          const isActive = isChapterActive && currentTrack?.type === type;
          const durationLabel = durations[key] ? formatTime(durations[key]) : "--:--";

          return (
            <VariantRow
              key={type}
              label={label}
              durationLabel={durationLabel}
              color={chapter.color}
              isActive={isActive}
              isPlaying={isPlaying}
              queuePosition={queueKeys.indexOf(key)}
              onPlay={() => onPlayVariant(index, type)}
              onToggleQueue={() => onToggleQueue(chapter.id, type)}
            />
          );
        })}
      </div>
    </div>
  );
};
